import { render, staticRenderFns } from "./ClicBadgeInterno.vue?vue&type=template&id=2720e8ce&"
import script from "./ClicBadgeInterno.vue?vue&type=script&lang=js&"
export * from "./ClicBadgeInterno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports